import React, {useEffect} from 'react'
import { StyleSheet, View, Text, ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import client, { useClient } from '@sart/client'
import { useContent } from '@sart/content'
import { adaptive, colors, backgroundColors, typography } from '@sart/styles'

import { Barcode } from '../Components';

import {
    Title,
    Button,
    Description,
    Space
  } from '@sart/components'
  
import { CompanyIcon } from '@sart/icons'

export default function ViewCashBarcode(props) {
  const {
    cache
  } = useClient()
  const content = useContent()

  const { navigation, route } = props

  const confirmedBasket = route.params?.confirmedBasket
  const message = confirmedBasket.message
  const total = confirmedBasket.total

  useEffect(() => {
    client.clearCachedPayment()
    // basketHelper.clearCacheBasket()
    client.setCache({basket: []})
  },[])

  function calculateTotalCost(){
    return (total / 100).toFixed(2) 
  }

  return (
    <ScrollView style={styles.container}>
      <View style={styles.wrapper}>        
        <Space height={12} />
        <View style={styles.logo}>
          <CompanyIcon  color={colors.white} height={styles.logoStyle.height} width={150} />
        </View>
        <Space height={24} />        
      
        <Title style={styles.title}>{content.payment_confirm.almostDone}</Title>
        <Space height={12} />        

        <Description style={styles.description}>{content.payment_confirm.cashDescription}</Description>
        <Space height={12} />        
        {/* Unsure if 'CODE128' format is correct */}
        <Barcode value={message} format={'CODE128'} text={message} width={styles.barcodeSize.width} />
        <Description style={styles.price}>{content.checkout.total} £{calculateTotalCost()} {content.payment_confirm.currencyCode}</Description>
        <Space height={24} />
        
        <Button
          style={styles.button}
          title={content.payment_confirm.action}
          onPress={() => {
            navigation.popToTop()
            navigation.navigate('Dashboard')
          }}
          titleStyle={{...typography.extrabold, fontSize: 18}}
        />
        <Space height={24} />        
      </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.srDarkGreen,
    ...adaptive.wrapperPadding,
  },
  wrapper: {
    flex: 1,
    backgroundColor: colors.srDarkGreen,
    ...adaptive.wrapperPadding,
    // justifyContent: 'center',
    alignItems: 'center'  
  },
  logo: {
    alignSelf:"center"
  },
  title: {
    color: colors.white,
    ...typography.bold,
    fontSize: 24
  },
  description: {
    color: colors.white,
    textAlign: 'center',
    ...typography.lightbold
  },
  button: {
      backgroundColor: colors.srGreen
  },
  barcodeSize: {
    width: 2.48
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  price: {
    backgroundColor: colors.srGreen,
    color: colors.clear,
    ...typography.lightbold,
    textAlign: 'center',
    width: 300
  }
})
